var map = {
	"./pic_1.png": 405,
	"./pic_2.png": 404,
	"./pic_3.png": 403,
	"./pic_4.png": 402,
	"./pic_5.png": 401,
	"./pic_6.png": 400,
	"./pic_7.png": 399,
	"./pic_8.png": 398,
	"./robt_0.png": 397,
	"./robt_1.png": 396,
	"./robt_2.png": 395,
	"./robt_3.png": 394,
	"./robt_4.png": 393,
	"./robt_5.png": 392,
	"./robt_6.png": 391,
	"./robt_7.png": 390,
	"./robt_8.png": 389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 268;